import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of, map } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Roles } from '../enums/roles';
import { CaseService } from '../../services/case.service';

@Injectable({
  providedIn: 'root',
})
export class CaseAccessGuard implements CanActivate {
  private authService = inject(AuthService);
  private caseService = inject(CaseService);
  constructor() {} // private router: Router

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const currentUser = this.authService.currentUserValue;

    if (currentUser.role === Roles.Administrator || currentUser.role === Roles.Guest || currentUser.role === Roles.Adjuster || currentUser.role === Roles.Investigator || currentUser.role === Roles.Secretary) {
      // If user is admin allow access
      return of(true);
    } else {
      if (route.paramMap.get('id')) {
        // check if  the id of the case exists
        const caseId = route.paramMap.get('id') as string;
        return this.caseService.getCaseById(caseId).pipe(
          map((result) => {
            if (
              result.caseData &&
                String(result.caseData.caseManagerId) === String(currentUser.userId)
            ) {
              return true;
            } else {
              console.warn('Case access denied:', {
                caseId,
                userId: currentUser.userId,
                caseManagerId: result.caseData?.caseManagerId,
                userRole: currentUser.role
              });
              return false;
            }
          })
        );
      }
      return of(false);
    }
  }
}
